import { Container, Box } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React from "react";
import MakeModelYearForm from "../MakeModelYearForm";
import { COLORS } from "../../constants";

const DesktopMakeModelYear = ({
                                  makeOptions,
  handleUserVehicleChange,
  loading,
  variantOptions,
  yearOptions,
  modelOptions,
  userInput,
  setUserInput,
  submit,
  showHeader,
}) => {
  return (
    <Box sx={{ py: 4, backgroundColor: COLORS.themeBlack }}>
      {/* <Typography variant="h5" sx={{ mb: 3, textAlign: 'center', color: '#ffffff' }}>
				Search by Make Model Year
			</Typography> */}
      <MakeModelYearForm
          makeOptions={makeOptions}
          handleUserVehicleChange={handleUserVehicleChange}
          loading={loading}
          variantOptions={variantOptions}
          yearOptions={yearOptions}
          modelOptions={modelOptions}
          userInput={userInput}
          setUserInput={setUserInput}
          submit={submit}
          inputsPerRowDesktop={4}
          darkMode={false}
          showHeader={showHeader}
      />
    </Box>
  );
};

export default DesktopMakeModelYear;
